import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Button } from '@mui/material';

function LoadMoreButton({ paging: { total_pages: totalPages, page }, onClick }: any) {
  const noMorePages = page >= totalPages;
  if (noMorePages || !page) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 4,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Button
        color="primary"
        onClick={() => {
          onClick('page', page + 1);
        }}
      >
        <FormattedMessage id="LOAD_MORE" />
      </Button>
    </Box>
  );
}

export default LoadMoreButton;
